import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IAuditTrailReportPayload {
    recordId: string
    performedBy: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const auditTrailReportSlice = createSlice({
    name: 'reporting/audit-trail-report',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAuditTrailReportPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const auditTrailReportActions = auditTrailReportSlice.actions
export default auditTrailReportSlice.reducer
